/**
 * @file 子路由渲染组件
 * @author lizhaoxia<lizhaoxia@baijiahulian.com>
 * @date 2020-02-24
 */
import {Switch, Route, Redirect} from 'react-router-dom';
import {joinPath} from '~/utils/url';

/* eslint-disable */
export default function SubRoutes(props) {
    const {routes} = props;

    return (
        <Switch>
            {
                routes.map(route => {
                    const {match: {path}} = props;
                    const {path: subPath = '', component, exact = true, subRoutes = [], redirect, slot} = route;

                    const key = joinPath(path, subPath);

                    if (redirect) {
                        return <Redirect key={key} to={redirect} />;
                    }

                    const Component = component;

                    if (subRoutes.length) {
                        const render = props => {
                            if (!Component) {
                                return <SubRoutes {...props} routes={subRoutes} />;
                            }

                            if (slot) {
                                return (
                                    <Component {...props} routeConfig={route}>
                                        <SubRoutes {...props} routes={subRoutes} />
                                    </Component>
                                );
                            }

                            return [
                                <Component {...props} key="parent" routeConfig={route} />,
                                <SubRoutes {...props} key="children" routes={subRoutes} />
                            ];
                        };

                        return (
                            <Route
                                {...props}
                                exact={exact}
                                key={key}
                                path={key}
                                // eslint-disable-next-line
                                render={render}
                            />
                        );
                    }

                    const render = props => <Component {...props} routeConfig={route} />;

                    return (
                        // eslint-disable-next-line
                        <Route {...props} exact={exact} key={key} path={key} render={render} />
                    );

                })
            }
        </Switch>
    );
}
